import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const LaptopIcon = ({
  width = 16,
  fill = '#334155',
  height = 16
}: SVGComponentProps) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14 10.666V4.799c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.658-.145-1.405-.145H4.133c-.746 0-1.12 0-1.405.145a1.34 1.34 0 0 0-.583.583C2 3.679 2 4.053 2 4.799v5.867m1.111 2.667h9.778c.413 0 .62 0 .79-.046.46-.123.82-.482.942-.943.046-.17.046-.376.046-.79 0-.206 0-.31-.023-.394a.67.67 0 0 0-.471-.471c-.085-.023-.188-.023-.395-.023H2.222c-.206 0-.31 0-.394.023a.67.67 0 0 0-.472.471c-.023.085-.023.188-.023.395 0 .413 0 .62.046.79.123.46.483.819.943.942.17.046.376.046.79.046"
        stroke={fill}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { LaptopIcon };
